import messages from './messages';
import { StateProgramSetup } from '../StateProgramSetup';
import PropertyStateConfig from '../../../PropertyStateConfig';

const NOAHSetup = ({
  editMode,
  onChange,
  values,
  promptToaster,
  isLoadingPassbookRateData,
  state,
  stateConfigs,
}: Props) => {
  const noahConfig = {
    programName: 'NOAH',
    titleMessage: messages.title,
    showInterimCerts: true,
    showRecertType: true,
    showOverrideQualification: true,
    showAnnualRecertMonth: true,
  };

  return (
    <>
      <StateProgramSetup
        editMode={editMode}
        onChange={onChange}
        values={values}
        promptToaster={promptToaster}
        isLoadingPassbookRateData={isLoadingPassbookRateData}
        config={noahConfig}
      />

      <PropertyStateConfig
        editMode={editMode}
        onChange={onChange}
        state={state}
        stateConfigs={stateConfigs}
        affordableProgramName={noahConfig.programName}
      />
    </>
  );
};

export default NOAHSetup;
